import {Avatar, Image} from 'antd'
import {getType} from 'apis/model/base'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import WorkspaceContext from '../WorkspaceContext'
import {BiSolidChurch} from "react-icons/bi";
import useTranslate from "../../../modules/local/useTranslate";
import {useSelector} from "react-redux";
import {getLogin} from "../../../redux/auth/selectors";
import getAvatar from "../../../helpers/getAvatar";
import {getId} from "../../../apis/model/base";
import {PhotoPlaceholderApp} from "../../../conts/imageBase64";
import DrawDialog from "../../../components/drawer/dialog/DrawDialog";
import {RiExchangeFill} from "react-icons/ri";
import AdminOrganizations from "./AdminOrganizations";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";

const WorkspaceBanner = ({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext)
    const login = useSelector(getLogin) || {}
    const {primary_org, org} = login

    const {photos = []} = organization ?? {}

    const cover_photo = organization?.cover_photo || _.get(photos, '0')

    const explorerOrg = org || primary_org;

    const org_id = _.isString(explorerOrg) ? explorerOrg : getId(explorerOrg)

    if (_.isEmpty(organization)) return null

    return (
        <Wrapper className="container mx-auto background-50 flex items-center gap-3">
            {isLg ? (
                <div className="mt-3 mx-3 w-full flex items-center gap-3">
                    <Avatar
                        size={60}
                        src={getAvatar(organization)}
                        icon={<BiSolidChurch size={30} className="text-color-500"/>}
                        style={{boxShadow: '0px 2px 4px -1px #dedede'}}
                        className="flex flex-center border-3 border-white background-200 custom-avt-rounded-lg"
                    />
                    <div className="flex items-center flex-1 gap-3">
                        <div style={{marginBottom: '0.25rem'}} className="flex flex-col flex-1">
                            <Link
                                to={getLinkToDetail(organization)}
                                style={{lineHeight: 1.2, marginBottom: '0.15rem'}}
                                className="font-bold text-lg text-color-000 no-underline tracking-wide">
                                {getTitle(organization)}
                            </Link>
                            <span className="font-medium text-doc-sm text-blue-500 italic leading-tight">
                                {t(getType(organization))}
                            </span>
                        </div>
                        <DrawDialog
                            width={540}
                            closable={true}
                            title={
                                <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                    {t('select organization')}
                                </div>
                            }
                            component={
                                <div
                                    style={{width: 32, height: 32, cursor: 'pointer'}}
                                    className="flex flex-center hover:background hover:shadow-md hover:scale-120 rounded-full text-green-500 hover:text-primary">
                                    <RiExchangeFill size={22}/>
                                </div>
                            }>
                            {(isToggle, toggle) => isToggle && (
                                <AdminOrganizations orgId={org_id} onClose={toggle}/>
                            )}
                        </DrawDialog>
                    </div>
                </div>
            ) : (
                <div className="flex flex-col flex-1 relative">
                    <Image
                        preview={false}
                        src={cover_photo || PhotoPlaceholderApp}
                        fallback={PhotoPlaceholderApp}
                        style={{height: 120}}
                        className="object-cover rounded-t-lg"
                        wrapperClassName="w-full"
                    />
                    <div style={{marginTop: -15}} className="mx-3 flex items-end gap-3">
                        <Avatar
                            size={60}
                            src={getAvatar(organization)}
                            icon={<BiSolidChurch size={30} className="text-color-500"/>}
                            style={{boxShadow: '0px 2px 4px -1px #dedede'}}
                            className="flex flex-center border-3 border-white background-200 custom-avt-rounded-lg"
                        />
                        <div className="flex items-center flex-1 gap-3">
                            <div style={{marginBottom: '0.25rem'}} className="flex flex-col flex-1">
                                <Link
                                    to={getLinkToDetail(organization)}
                                    style={{lineHeight: 1.2, marginBottom: '0.15rem'}}
                                    className="font-bold text-sm md:text-base text-color-000 max-lines-1 no-underline tracking-wide">
                                    {getTitle(organization)}
                                </Link>
                                <span
                                    style={{fontSize: '0.7rem'}}
                                    className="flex-1 font-medium text-blue-500 italic leading-tight">
                                {t(getType(organization))}
                            </span>
                            </div>
                            <DrawDialog
                                width={540}
                                closable={true}
                                title={
                                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                        {t('select organization')}
                                    </div>
                                }
                                component={
                                    <RiExchangeFill size={22}
                                                    className="text-color-500 hover:text-primary cursor-pointer"/>
                                }>
                                {(isToggle, toggle) => isToggle && (
                                    <AdminOrganizations orgId={org_id} onClose={toggle}/>
                                )}
                            </DrawDialog>
                        </div>
                    </div>
                </div>
            )}
        </Wrapper>
    )
}

export default WorkspaceBanner
